// extracted by mini-css-extract-plugin
export default {"priorityLink":"PriorityLinks_priorityLink__Wt84B textSmall","highlight":"PriorityLinks_highlight__rzoGh","priorityLinkLabel":"PriorityLinks_priorityLinkLabel__dtwxY"};